export default __webpack_public_path__ + "static/media/maze5.7761582d.png";